import { ReactNode } from "react";
import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
import "./dashboardGraphs.css";

interface ChartCardProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  loading?: boolean;
  error?: string | null;
  empty?: boolean;
  emptyMessage?: string;
  onRetry?: () => void;
  height?: number;
  className?: string;
  children?: ReactNode;
}

/**
 * Card container for dashboard widgets with loading / error / empty states.
 */
export default function ChartCard({
  title,
  subtitle,
  actions,
  loading = false,
  error = null,
  empty = false,
  emptyMessage = "Sin datos para los filtros seleccionados",
  onRetry,
  height = 320,
  className = "",
  children,
}: ChartCardProps) {
  const renderBody = () => {
    if (loading) {
      return <Skeleton width="100%" height={`${height}px`} />;
    }
    if (error) {
      return (
        <div className="dg-card-state" style={{ minHeight: height }}>
          <i className="pi pi-exclamation-triangle dg-card-state-icon error" />
          <span>{error}</span>
          {onRetry ? (
            <Button
              label="Reintentar"
              icon="pi pi-refresh"
              size="small"
              text
              onClick={onRetry}
            />
          ) : null}
        </div>
      );
    }
    if (empty) {
      return (
        <div className="dg-card-state" style={{ minHeight: height }}>
          <i className="pi pi-inbox dg-card-state-icon" />
          <span>{emptyMessage}</span>
        </div>
      );
    }
    return children;
  };

  return (
    <section className={`dg-card ${className}`}>
      <header className="dg-card-header">
        <div>
          <h5 className="dg-card-title">{title}</h5>
          {subtitle ? <div className="dg-card-subtitle">{subtitle}</div> : null}
        </div>
        {actions ? <div className="dg-card-actions">{actions}</div> : null}
      </header>
      <div className="dg-card-body">{renderBody()}</div>
    </section>
  );
}
